namespace RioERP.Orders {
    export namespace OrderBrandAmbassadorShareService {
        export const baseUrl = 'Orders/OrderBrandAmbassadorShare';

        export declare function Create(request: Serenity.SaveRequest<OrderBrandAmbassadorShareRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderBrandAmbassadorShareRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderBrandAmbassadorShareRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderBrandAmbassadorShareRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderBrandAmbassadorShare/Create",
            Update = "Orders/OrderBrandAmbassadorShare/Update",
            Delete = "Orders/OrderBrandAmbassadorShare/Delete",
            Retrieve = "Orders/OrderBrandAmbassadorShare/Retrieve",
            List = "Orders/OrderBrandAmbassadorShare/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrderBrandAmbassadorShareService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
